import { ReactNode } from 'react';
import { Text, TextField } from 'react-aria-components';
import { Label } from '../../atoms/label/label';
import { Typography } from '../../atoms/typography/typography';
import { field, hint as hintStyles } from './variants';
import { twMerge } from 'tailwind-merge';
import { Modal, TextButton } from '@maia/ui';
import { IconInfoCircle } from '@maia/icons';

export type FormFieldProps = {
  label: string;
  description?: string;
  hint?: string;
  error?: string;
  inputSlot: ReactNode;
  className?: string;
  wrapperField?: any;
  htmlFor?: string;
  moreInfo?: string;
};

export function FormField({
  wrapperField: WrapperField = TextField,
  ...props
}: FormFieldProps) {
  const {
    label,
    description,
    hint,
    error,
    inputSlot,
    className,
    moreInfo,
    htmlFor,
  } = props;

  return (
    <WrapperField className={twMerge(field(), className)}>
      <div className="inline-flex items-center mb-12 justify-between">
        <Label weight="medium" size="body-s" htmlFor={htmlFor}>
          {label}
        </Label>
        {moreInfo && (
          <Modal
            content={moreInfo}
            triggerSlot={
              <TextButton size="small">
                <span className="flex items-center gap-8">
                  Meer informatie
                  <IconInfoCircle className="size-20" />
                </span>
              </TextButton>
            }
          />
        )}
      </div>

      {description && (
        <Typography className="mb-12 leading-1">{description}</Typography>
      )}

      {inputSlot}

      {(error || hint) && (
        <Text
          slot="description"
          className={hintStyles({ intent: error?.length ? 'error' : 'hint' })}
        >
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-currentColor leading-1"
          >
            {error ?? hint}
          </Typography>
        </Text>
      )}
    </WrapperField>
  );
}
